__turbopack_context__.v({
  "profile": "QZN4uW_profile",
  "profile_contact_list": "QZN4uW_profile_contact_list",
  "profile_contact_list_item_key": "QZN4uW_profile_contact_list_item_key",
  "profile_contact_list_item_value": "QZN4uW_profile_contact_list_item_value",
  "profile_info_list": "QZN4uW_profile_info_list",
  "profile_info_list_desktop": "QZN4uW_profile_info_list_desktop",
  "profile_info_list_desktop_item": "QZN4uW_profile_info_list_desktop_item",
  "profile_info_list_desktop_item_key": "QZN4uW_profile_info_list_desktop_item_key",
  "profile_info_list_desktop_item_value": "QZN4uW_profile_info_list_desktop_item_value",
  "profile_info_list_mobile": "QZN4uW_profile_info_list_mobile",
  "profile_info_list_mobile_item": "QZN4uW_profile_info_list_mobile_item",
  "profile_info_list_mobile_item_key": "QZN4uW_profile_info_list_mobile_item_key",
  "profile_info_list_mobile_item_value": "QZN4uW_profile_info_list_mobile_item_value",
  "profile_info_name": "QZN4uW_profile_info_name",
  "profile_info_name_key": "QZN4uW_profile_info_name_key",
  "profile_info_name_value": "QZN4uW_profile_info_name_value",
  "profile_location": "QZN4uW_profile_location",
  "profile_location_list": "QZN4uW_profile_location_list",
  "profile_location_list_item_key": "QZN4uW_profile_location_list_item_key",
  "profile_location_list_item_value": "QZN4uW_profile_location_list_item_value",
  "profile_photo": "QZN4uW_profile_photo",
  "profile_photo_description": "QZN4uW_profile_photo_description",
  "profile_photo_image": "QZN4uW_profile_photo_image",
  "profile_photo_info": "QZN4uW_profile_photo_info",
  "profile_photo_info_list": "QZN4uW_profile_photo_info_list",
  "profile_photo_info_list_item": "QZN4uW_profile_photo_info_list_item",
  "profile_photo_info_list_item_key": "QZN4uW_profile_photo_info_list_item_key",
  "profile_photo_info_list_item_value": "QZN4uW_profile_photo_info_list_item_value",
  "pronounce": "QZN4uW_pronounce",
});
